import { ChangeEvent } from 'react'
import classNames from 'classnames'
import { IEventData, IErrors } from 'interface/calendar'

interface IEventTitleInputProps {
  eventData: IEventData
  setEventData: React.Dispatch<React.SetStateAction<IEventData>>
  errors: IErrors
  setErrors: React.Dispatch<React.SetStateAction<IErrors>>
}

export const EventTitleInput: React.FC<IEventTitleInputProps> = ({
  eventData,
  setEventData,
  errors,
  setErrors,
}) => {
  const handleChangeTitle = (evt: ChangeEvent<HTMLInputElement>) => {
    setEventData((prevData) => ({ ...prevData, title: evt.target.value }))
    setErrors({
      ...errors,
      title: [],
    })
  }

  return (
    <div>
      <input
        type="text"
        placeholder="Add Title"
        className={classNames(
          'w-full h-[38px] px-[13px] border outline-none rounded-lg text-sm font-normal leading-4 placeholder-[#A9A9A9] text-[#111827]',
          errors.title?.length && '!text-red-600 border-red-500'
        )}
        value={eventData.title}
        onChange={handleChangeTitle}
      />
      {errors.title?.map((error, index) => (
        <p
          key={index}
          className="mt-1 text-xs text-red-600 dark:text-red-500"
        >
          {error}
        </p>
      ))}
    </div>
  )
}
